export default "__VITE_ASSET__af9fb0ac__"